'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _typeof = require('./../../external/@babel/runtime/helpers/esm/typeof.js');
var React = require('react');
var index = require('./../../external/classnames/index.js');
var PropTypes = require('prop-types');
require('../Alert/Alert.js');
require('../Article/Article.js');
require('../ArticleInfoBlock/ArticleInfoBlock.js');
require('../Banner/Banner.js');
require('../BreadCrumbs/BreadCrumbs.js');
require('../ErrorPage/ErrorPage.js');
require('../FeatureCarousel/FeatureCarousel.js');
require('../FeatureCarousel/FeaturedCarouselItem/FeaturedCarouselItem.js');
require('../FeaturedMarquee/FeaturedMarquee.js');
require('../NewsletterSubscription/NewsletterSubscription.js');
require('../OpenPositions/OpenPositions.js');
require('../OurTeam/OurTeam.js');
require('../PageHeader/PageHeader.js');
require('../Pagination/Pagination.js');
require('../PaginationContainer/PaginationContainer.js');
require('../PanelGroup/PanelGroup.js');
require('../PanelGroup/Panel/Panel.js');
require('../PodcastCarousel/PodcastCarousel.js');
require('../SecondaryNav/SecondaryNav.js');
var Section = require('../Section/Section.js');
require('../Section/SectionHeader/SectionHeader.js');
require('./SplitBannerImage/SplitBannerImage.js');
require('./SplitBannerVideo/SplitBannerVideo.js');
require('./SplitBannerContent/SplitBannerContent.js');
require('./SplitBannerContact/SplitBannerContact.js');

function _interopDefault (e) { return e && e.__esModule ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefault(React);
var PropTypes__default = /*#__PURE__*/_interopDefault(PropTypes);

var SplitBanner = function SplitBanner(_ref) {
  var id = _ref.id,
    children = _ref.children,
    className = _ref.className,
    isLinkable = _ref.isLinkable,
    small = _ref.small;
  var splitbannerClasses = index.default('lanl-splitbanner', small && 'small', className);
  return /*#__PURE__*/React__default.default.createElement(Section.Section, {
    id: id,
    isLinkable: isLinkable,
    noStyling: true,
    className: splitbannerClasses
  }, small ? /*#__PURE__*/React__default.default.createElement("div", {
    className: "small-container"
  }, children) : children);
};
SplitBanner.defaultProps = {
  id: null,
  isLinkable: false,
  small: false
};
SplitBanner.propTypes = {
  children: PropTypes__default.default.node,
  className: PropTypes__default.default.string,
  id: function id(props, propName, componentName) {
    if (props['isLinkable'] && !props[propName]) {
      return new Error('id prop is required if isLinkable prop is true');
    }
    if (props[propName] && typeof props[propName] !== 'string') {
      return new Error("Invalid prop id of type '".concat(_typeof.default(props[propName]), "' supplied to '").concat(componentName, "', expected 'string' "));
    }
  },
  isLinkable: PropTypes__default.default.bool,
  small: PropTypes__default.default.bool
};

exports.SplitBanner = SplitBanner;
exports.default = SplitBanner;
//# sourceMappingURL=SplitBanner.js.map
